/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 18.05.2016.
 */

import React, {Component, PropTypes} from 'react';
import ReactDOM from 'react-dom';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import Platform from 'platform';
import ClassNames from 'classnames';

import _isEqual from 'lodash/isEqual';
import _get from 'lodash/get';
import _debounce from 'lodash/debounce';

import {FadeOutEl, FadeInEl} from '../../../utils';

import Translate from '../../../components/Translate';

import {SetBookmark} from '../../../actions/common/actions-common';
import {OpenMessage, CloseMessage} from '../../../actions/common/actions-common';

import tv2zAnalyticsInstance from '../../../services/tv2z';

import {ACTIONS} from '../index';

export const STATES = {
  IDLE: 0, // when player has been created or released
  PREPARING: 1, // when player receives the api command to load the movie until it starts requesting the first fragment
  BUFFERING: 2, // when player doesn't have enough data to play the content for any reasons
  PLAYING: 3, // when player starts playing content
  PAUSED: 4, // when player is stopped
  ENDED: 5, // when video is ended
  ERROR: 6, // when player encounters an error
};

export const SYNC_POSITION_IN_PERCENT = 0.15;

class Clpp extends Component {
  videoNode = null;
  constructor(props) {
    super(props);

    this.player = null;
    this.isFirstError = true;
    this.monitoring = null;

    this.state = {
      //state: STATES.IDLE,
      isInit: false,
      isError: false,
      errorMsg: '',
    };

    this.SetBookmark = _debounce(this.props.SetBookmark.bind(this), 1200);
  }

  componentDidMount() {

    this.setState({
      isError: false,
      errorMsg: ''
    });

    this.monitoring = this.props.player.monitoring;

    this.setState({
      player: this.props.player,
    });

    this.__processAction();
  }

  componentWillReceiveProps(newProps) {

    if (!_isEqual(newProps.player, this.props.player)) {
      this.setState({
        isError: false,
        errorMsg: ''
      });

      this.__processAction(newProps);
    }

    if (!_isEqual(newProps.player.monitoring, this.props.player.monitoring)) {
      this.monitoring = newProps.player.monitoring;
    }
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

  __processAction(props = this.props) {

    switch (props.player.action) {
      case ACTIONS.OPEN:

        if (this.vliveLogo) {
          this.vliveLogo.parentNode.removeChild(this.vliveLogo);
          this.vliveLogo = null;
        }

        if (!this.state.isInit) {

          this._initPlayer(props.player);
        } else {
          this._loadPlaylist([{
            src: props.player.stream_url,
          }]);
        }

        this.setState({
          getUrlAgain: props.player.get_url_again_fn
        });

        break;

      case ACTIONS.CLOSE:

        this.Stop();
        break;

      case ACTIONS.RESIZE_DETACHED:

        this.SetSize(props.player.width, props.player.height);

        break;
    }
  }

  Play() {

    return this.player && this.player.play();
  }

  Stop() {

    return this.player && this.player.stop();
  }

  Seek(position) {

    return this.player && this.player.seek(position);
  }

  SetSize(width, height) {

    // this.player && this.player.resize(width || 460, height || 270);
    // this.player.dispose().then(() => {
    //   this._initPlayer(props.player);
    // });
  }

  Ref = (node) => {
    this.videoNode = node;
  };

  _initPlayer(opt) {
    this.setState({isInit: true});

    this.player = clpp.init(this.videoNode, {
      autoplay: (Platform.name === 'Safari' || platform.manufacturer === 'Apple') ? false : _get(this.props.player, 'autostart', true),
      license: 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpbHYiOmZhbHNlLCJ0eXBlIjoiV2ViIiwidXJscyI6WyI6Ly9jbG91ZGNvbm54dC5jb20iLCI6Ly9keWEudHYiLCI6Ly9leHBhdHR2LnVzIiwiOi8vZmxpeG9uLnR2IiwiOi8vZ29mbGl4b24uY29tIiwiOi8vbWV0cm9wbGV4LmlvIiwiOi8vbXktaW50ZXJuZXR0di5jb20iLCI6Ly9JbnRlY2dzLmNvbSIsIjovL2JvbGx5YW5kYmV5b25kLmNvbSIsIjovL3dpZmktbGl2ZS50diIsIjovL25vaXN5cGVhay5jb20iLCI6Ly9jbG91ZC50ZWxlbmV0LmJnIiwiOi8vc290YWxjbG91ZC5jb20iXSwia2lkIjoxNTQ4fQ.BGbAaQmBSG3iZF-p3JdJPvE6au0xAndmuBwJ5rqDsk3Z2spTjUwQIgUCvLCA5umw8ax8HafDwVFTT_yXACSapicioQ6LrKo526bFCElG5N39H5-X09Pm4DBNqybe8lxTtH5c1stz-8o8CouyKZBIYjmYEoik8BdEQtM8csXvZC21EiVJGEujXaxX5m6JEa_noSh7J4SpJ9w6fbde9wR8P73039sb4sy0oF9yJe6sYjQBZvVC25xXgWdSem4UTy5rcsYO3d4DZvfa7r2Fx26Bpnu_e_2n8kmRSALZQNwFWvxwUN5AmzUE3j4p9e9UgQhdh50KyZonrpvMl0d_eY3FPw',
      startTime: _get(this.props.player, 'position', 0),
      drmtoday: {
        userId: 'purchase',
        sessionId: 'p0',
        merchant: 'six',
        environment: clpp.statics.drmtoday.STAGING
      },
      plugins: _get(Config, 'analytics.youbora', true) ? {
        clpp_npaw: {
          properties: {
            projectcode : Config.operator_ext_id,
            content_id:  _get(this.monitoring, 'assetID', ''),
            content_type: _get(this.monitoring, 'type', ''),
            device: {
              name: Platform.name,
              description: Platform.description,
              os: {
                architecture: Platform.os.architecture,
                family: Platform.os.family,
                version: Platform.os.version,
              }
            }
          },
          media: {
            title:  _get(this.monitoring, 'assetTitle', ''),
            isLive:  _get(this.monitoring, 'type', '') === 'channel',
          },
          accountCode: 'sotalcloud',
          enableAnalytics: true,

          username: _get(this.props, 'user.user') || 'Unknown Hamster',

          // Optional features
          parseCDNNodeHost: false,
          haltOnError: false,
          httpSecure: true,

          extraParams: {
            param1 : Config.operator_ext_id
          }
        }
      } : {},
    });

    this._bindEvents(this.player);

    this._loadPlaylist([{
      src: opt.stream_url,
    }]);

    if (_get(Config, 'analytics.tv2z', false)) {
      tv2zAnalyticsInstance.setContentInfo(
        _get(this.monitoring, 'assetID'),
        _get(this.monitoring, 'type'),
        _get(this.monitoring, 'programID'),
        _get(this.monitoring, 'duration'),
      );
    }
  }

  _handleError = (error) => {
    console.log('clpp error', error);
    if (_get(error, 'httpStatusCode', '') === 401) {
      this.props.onLimitReached && this.props.onLimitReached();
      return;
    }

    if (error && ['Android', 'iOS'].indexOf(Platform.os.family) !== -1 && (error.name === 'MEDIA_ERR_SRC_NOT_SUPPORTED')) {
      this.props.OpenMessage({
        type: 'apps',
        actions: [
          {
            title: 'close',
            func: () => {
            }
          }
        ]
      });
    }
    if (this.isFirstError && this.state.getUrlAgain) {
      this.isFirstError = false;

      this.setState({errorMsg: _get(error, 'originalError.message')});
      this._reloadStream();
      console.log('clpp error', error);
    } else {

      this.setState({isError: true, errorMsg: _get(error, 'originalError.message')});
      console.log('clpp error', error);
    }
  }

  _bindEvents(player) {
    player.on(clpp.statics.events.CLPP_PLAYER_PROXY_READY, () => {
      if (_get(Config, 'analytics.tv2z', false)) {
        tv2zAnalyticsInstance.initScan();
      }
    });

    player.on(clpp.statics.events.CLPP_PLAYER_STATE_CHANGED, (e) => {
      if (_get(e, 'details.currentState') === STATES.PLAYING) {
        this.setState({isError: false, errorMsg: null});
      }

      if (_get(e, 'details.currentState') === STATES.PAUSED) {
        if (_get(Config, 'bookmark_allowed', false) && _get(this.props.player, 'stream_type', null) === 'vod_hls' && !!_get(this.props.player, 'asset_id')) {

          this.props.SetBookmark(_get(this.props.player, 'asset_id'), parseInt(player.currentTime() || 0, 10));
        }
      }
    });

    player.on('error', (event) => {
      const error = event.details;
      this._handleError(error);
    });

    player.on('timeupdate', (data) => {
      const position = player.currentTime();
      const duration = player.duration();
      if (_get(Config, 'bookmark_allowed', false) && _get(this.props.player, 'stream_type', null) === 'vod_hls' && !!_get(this.props.player, 'asset_id')) {

        if (!!parseInt(position, 10) && (parseInt(position, 10) % parseInt(duration * SYNC_POSITION_IN_PERCENT, 10) === 0)) {

          this.SetBookmark(_get(this.props.player, 'asset_id'), parseInt(position, 10));
        }
      }
    });
  }

  _loadPlaylist(playlist) {

    this.player.load(playlist).catch((error) => {
      this._handleError(error)
    });
  }

  _reloadStream() {
    this.setState({isError: false});

    this.state.getUrlAgain && this.state.getUrlAgain()
      .then((stream_url) => {

        this._loadPlaylist([{src: stream_url}]);
      }, () => {

        this.setState({isError: true});
      });
  }

  render() {
    const width = _get(this.props, 'player.width', 460);
    const height = _get(this.props, 'player.height', 270);

    const noSignalClass = ClassNames({
      'show': this.state.isError,
      'player-no-signal crow no-gutter': true
    });

    return (<div>
      <div id="player_no_signal" className={noSignalClass}>
        <p className="p no-signal-text"><Translate content="player.no_signal" />
          <span className="p player-error-text"> {this.state.errorMsg} </span>
          <span className="mv- pv btn-dark pointer"
                onClick={this._reloadStream.bind(this)}
                style={{display: 'block', float: 'none'}} title={Translate.translator('player.reload')}>
            <i className="ic ic-reload ic-24px"></i>
          </span>
        </p>
      </div>
      <div data-vjs-player>
        <video ref={this.Ref}
               width={width} height={height} controls
               className="video-js vjs-default-skin vjs-big-play-centered"></video>
      </div>
    </div>);
  }
}

Clpp.propTypes = {
  player: PropTypes.object.isRequired,
  onLimitReached: PropTypes.func,
};

const mapStateToProps = ({auth: {user}}) => {
  return {
    user: user,
  };
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({SetBookmark, OpenMessage, CloseMessage}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Clpp);



// WEBPACK FOOTER //
// ./src/containers/Player/CLPP/clpp.js